module.exports = __webpack_public_path__ + "img/img-102.a912f9f8.png";